import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _slicedToArray from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.object.freeze";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import Loading from 'quasar/src/plugins/Loading.js';
import Vue from 'vue';
import Vuex from 'vuex'; // import 'meteor.bundle' // Get meteor bundler in /node_modules

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import { Adverts, Measures, Notices, Land, UserData, KV } from 'api/collections';
import { KV_AREA_FACTS_ON } from 'api/core/kv';
import { FanCounts } from 'api/core/fanCounts';
import { isOwner as isOwnerUser, isVerifiedOwner } from 'api/owners/rules';
import { seesAdminScreens, isSuperadmin as isSuperadminUser, isFan } from 'api/core/roles'; // export const UserData = new Meteor.Collection('userData')

var usersSub = Meteor.subscribe('thisNameDoesNotMatter'); // a login stored in the browser (Meteor resumes it on start): the app loader's steps before the login is known (#223)

var hasStoredLogin = function hasStoredLogin() {
  try {
    return !!window.localStorage.getItem('Meteor.loginToken');
  } catch (e) {
    return false;
  }
}; // import { Loading /*, debounce*/ } from 'quasar'


import Loading from 'quasar/src/plugins/Loading.js';;
import geojsonArea from '@mapbox/geojson-area';
Vue.use(Vuex);
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

var storeInstance; // The big lists mirrored from Meteor (every fan's areas, every user) are read-only snapshots: their tracker makes them
// anew from minimongo on every change, so nothing needs Vue to watch inside an item. A frozen item is skipped by Vue's
// reactivity and by Vuex's strict mode on dev, which walked every point of every area on each commit: saving an area
// blocked the browser 0.8 + 1.2 s on dev, 0.25 + 0.25 s in a production build (#172). Change a copy, never an item:
// in script code the assignment throws, in a template it is ignored. The freeze is shallow, and nothing below an item
// is reactive any more. Not the communities (land): the poll page counts votes inside a community's polls in place.

var frozenItems = function frozenItems(list) {
  list.forEach(function (item) {
    return Object.freeze(item);
  });
  return list;
};

export default function ()
/* { ssrContext } */
{
  var Store = new Vuex.Store({
    state: {
      user: undefined,
      userid: undefined,
      authenticated: false,
      measures: [],
      land: [],
      KV: [],
      userData: [],
      // fans per community id (communityFanCounts, #520)
      fanCounts: {},
      measuresMine: [],
      score: -1,
      count: 0,
      ready: false,
      // the app loader (#223): which start-up subscriptions are ready, whether the login state is known, and
      // whether the first load is over (then the loader never shows again)
      subsReady: {},
      loginKnown: false,
      appStarted: false,
      // when the first load ended: a screen with a loader of its own that opens right then takes over from the
      // app loader without a second entrance (#291)
      appStartedAt: 0,
      drawnFeature: undefined,
      connected: false,
      showToolbar: true,
      notice: undefined,
      adverts: undefined
    },
    mutations: {
      // clearAuthData (state) {
      //   // state.idToken = userData.token
      //   state.userId = 'klaas'
      // },
      UPDATE_USER_STATE: function UPDATE_USER_STATE(state, user) {
        if (user) {
          state.authenticated = true;
          state.user = user;
          state.userid = Meteor.userId();
        } else {
          state.user = user;
          state.userid = Meteor.userId();
          state.authenticated = false;
        }
      },
      UPDATE_MEASURES_STATE: function UPDATE_MEASURES_STATE(state, measures) {
        state.measures = frozenItems(measures);
      },
      UPDATE_MY_MEASURES_STATE: function UPDATE_MY_MEASURES_STATE(state, measures) {
        state.measuresMine = frozenItems(measures).reverse();
        state.score = measures.length;
      },
      UPDATE_READY_STATE: function UPDATE_READY_STATE(state, value) {
        state.ready = value;
      },
      SUB_READY: function SUB_READY(state, name) {
        if (!state.subsReady[name]) state.subsReady = _objectSpread({}, state.subsReady, _defineProperty({}, name, true));
      },
      LOGIN_KNOWN: function LOGIN_KNOWN(state) {
        state.loginKnown = true;
      },
      APP_STARTED: function APP_STARTED(state) {
        state.appStarted = true;
        state.appStartedAt = Date.now();
      },
      UPDATE_DRAWNFEATURE_STATE: function UPDATE_DRAWNFEATURE_STATE(state, value) {
        state.drawnFeature = value.payload;
      },
      UPDATE_CONNECTED_STATE: function UPDATE_CONNECTED_STATE(state, value) {
        state.connected = value;
      },
      UPDATE_SHOWTOOLBAR_STATE: function UPDATE_SHOWTOOLBAR_STATE(state, value) {
        state.showToolbar = value;
      },
      UPDATE_NOTICES_STATE: function UPDATE_NOTICES_STATE(state, value) {
        state.notice = value;
      },
      UPDATE_LAND_STATE: function UPDATE_LAND_STATE(state, value) {
        state.land = value;
      },
      UPDATE_USERDATA_STATE: function UPDATE_USERDATA_STATE(state, value) {
        state.userData = frozenItems(value);
      },
      UPDATE_ADVERTS_STATE: function UPDATE_ADVERTS_STATE(state, value) {
        state.adverts = value;
      },
      UPDATE_KV_STATE: function UPDATE_KV_STATE(state, value) {
        state.KV = value;
      },
      UPDATE_FAN_COUNTS_STATE: function UPDATE_FAN_COUNTS_STATE(state, value) {
        state.fanCounts = Object.freeze(value);
      }
    },
    // modules: {
    //     measures
    // },
    strict: process.env.DEV,
    actions: {
      storeDrawnFeature: function storeDrawnFeature(_ref, payload) {
        var commit = _ref.commit;
        commit('UPDATE_DRAWNFEATURE_STATE', payload);
      },
      setShowToolbarState: function setShowToolbarState(_ref2, payload) {
        var commit = _ref2.commit;
        commit('UPDATE_SHOWTOOLBAR_STATE', payload);
      },
      initLoginStateTracker: function initLoginStateTracker(_ref3) {
        var commit = _ref3.commit;
        Tracker.autorun(function (c) {
          var user = Meteor.user();
          commit('UPDATE_USER_STATE', user);
        }); // known: not logging in (a stored login is being resumed), and logged out or the user's document is in

        Tracker.autorun(function (c) {
          if (!Meteor.loggingIn() && (!Meteor.userId() || Meteor.user())) {
            commit('LOGIN_KNOWN');
            c.stop();
          }
        });
        Tracker.autorun(function (c) {
          if (usersSub.ready()) {
            commit('SUB_READY', 'users');
            c.stop();
          }
        });
      },
      initConnectedStateTracker: function initConnectedStateTracker(_ref4) {
        var commit = _ref4.commit;
        Tracker.autorun(function (c) {
          var connected = Meteor.status().connected;
          commit('UPDATE_CONNECTED_STATE', connected);
        });
      },
      initAdvertsTracker: function initAdvertsTracker(_ref5) {
        var commit = _ref5.commit;
        Meteor.subscribe('adverts', {
          onReady: function onReady() {// commit('UPDATE_READY_STATE', true)
          }
        });
        Tracker.autorun(function (c) {
          var item = Adverts.find({}, {
            sort: {
              'dateCreated': -1
            }
          }).fetch(); // .map((item) => {
          //     let userData = UserData.findOne({ _id: item.properties.createdBy })
          //     item.properties.meazure = getMeazure(item)
          //     item.properties.userData = userData
          //     return item
          // })

          commit('UPDATE_ADVERTS_STATE', item);
        });
      },
      initNoticesTracker: function initNoticesTracker(_ref6) {
        var commit = _ref6.commit;
        Meteor.subscribe('notices', {
          onReady: function onReady() {
            commit('SUB_READY', 'notices');
          }
        });
        Tracker.autorun(function (c) {
          var item = Notices.findOne({}, {
            sort: {
              'dateCreated': -1
            }
          }); // .map((item) => {
          //     let userData = UserData.findOne({ _id: item.properties.createdBy })
          //     item.properties.meazure = getMeazure(item)
          //     item.properties.userData = userData
          //     return item
          // })

          commit('UPDATE_NOTICES_STATE', item);
        });
      },
      initLandTracker: function initLandTracker(_ref7) {
        var commit = _ref7.commit;
        Meteor.subscribe('land', {
          onReady: function onReady() {
            commit('SUB_READY', 'land');
          }
        });
        Tracker.autorun(function (c) {
          var item = Land.find({}, {
            sort: {
              'createdAt': -1
            }
          }).fetch(); // .map((item) => {
          //     let userData = UserData.findOne({ _id: item.properties.createdBy })
          //     item.properties.meazure = getMeazure(item)
          //     item.properties.userData = userData
          //     return item
          // })

          commit('UPDATE_LAND_STATE', item);
        });
      },
      initUserDataTracker: function initUserDataTracker(_ref8) {
        var commit = _ref8.commit;
        // no subscription of its own: the server has no 'userData' publication (subscribing to it was refused);
        // thisNameDoesNotMatter fills the userData collection: an admin gets every user, anyone else their own
        // document and the others' names and scores (core/server/userData.js, #520)
        Tracker.autorun(function (c) {
          var item = UserData.find({}, {
            sort: {
              'createdAt': -1
            }
          }).fetch(); // .map((item) => {
          //     let userData = UserData.findOne({ _id: item.properties.createdBy })
          //     item.properties.meazure = getMeazure(item)
          //     item.properties.userData = userData
          //     return item
          // })

          commit('UPDATE_USERDATA_STATE', item);
        });
      },
      initMeasuresTracker: function initMeasuresTracker(_ref9) {
        var commit = _ref9.commit;
        Meteor.subscribe('measures', {
          onReady: function onReady() {
            Loading.hide();
            commit('UPDATE_READY_STATE', true);
            commit('SUB_READY', 'measures');
          }
        });
        Tracker.autorun(function (c) {
          // let items = Measures.find({}, { sort: { dateCreated: -1 }, limit: 5 })
          var items = Measures.find({}, {
            sort: {
              'dateCreated': -1
            }
          }).map(function (item) {
            var userData = UserData.findOne({
              _id: item.createdBy
            });
            item.userData = userData; // item.properties = null

            return item;
          });
          commit('UPDATE_MEASURES_STATE', items);
        });
        Tracker.autorun(function (c) {
          var currentUserId = Meteor.userId(); // let items = Measures.find({ 'properties.createdBy': currentUserId }, { sort: { dateCreated: -1 }, limit: 1 })

          var items = Measures.find({
            'createdBy': currentUserId
          }, {
            sort: {
              'dateCreated': -1
            }
          }).map(function (item) {
            var userData = UserData.findOne({
              _id: item.createdBy
            });
            item.userData = userData; // return {
            //     ...item,
            //     foo2: 'bar2'
            // }

            return item;
          });
          commit('UPDATE_MY_MEASURES_STATE', items);
        });
      },
      initKVTracker: function initKVTracker(_ref10) {
        var commit = _ref10.commit;
        Meteor.subscribe('KV', {
          onReady: function onReady() {
            commit('SUB_READY', 'KV');
          }
        });
        Tracker.autorun(function (c) {
          var item = KV.find({}, {
            sort: {
              'key': -1
            }
          }).fetch();
          commit('UPDATE_KV_STATE', item);
        });
      },
      // the fans per community as counts only (#520): the browser gets the other users' names, not their communities
      initFanCountsTracker: function initFanCountsTracker(_ref11) {
        var commit = _ref11.commit;
        Meteor.subscribe('communityFanCounts');
        Tracker.autorun(function (c) {
          var counts = {};
          FanCounts.find().forEach(function (item) {
            counts[item._id] = item.count;
          });
          commit('UPDATE_FAN_COUNTS_STATE', counts);
        });
      },
      logout: function logout(_ref12) {
        var commit = _ref12.commit;
        commit('clearAuthData'); // localStorage.removeItem('expirationDate')
        // localStorage.removeItem('token')
        // localStorage.removeItem('userId')
        // router.replace('/signin')
      } // signup ({ commit }, payload) {
      //     commit('changeCCC', payload)
      //     // localStorage.removeItem('expirationDate')
      //     // localStorage.removeItem('token')
      //     // localStorage.removeItem('userId')
      //     // router.replace('/signin')
      // }

    },
    getters: {
      // thread: state => id =>
      // {
      //     let thread = null
      //     state.land.forEach(land => {
      //         return land.threads.find(thread => thread.id === id)
      //     })
      //     return thread
      // },
      // emailTemplates: state => id => state.land.find(land => land.id === id),
      // land: state => id => state.land.find(land => land.id === id),
      // ttt: state => type => state.KV.find(kv => kv.type === type),
      //           ttt: state => type => state.KV.find(kv => kv.type === type),
      kv: function kv(state) {
        return function (id) {
          return state.KV.find(function (kv) {
            return kv.id === id;
          });
        };
      },
      // the area facts experiment switched on (Maintenance, #533)
      areaFactsOn: function areaFactsOn(state) {
        return state.KV.some(function (kv) {
          return kv.key === KV_AREA_FACTS_ON && kv.value === true;
        });
      },
      // owner registration and community management (docs/claude/done/owner-registration-and-community-management-plan.md)
      // roles of the logged-in user (api/core/roles): the one place that knows where the flags live
      // the admin's screens (the test server's demo admin too, #472)
      isAdmin: function isAdmin(state) {
        return seesAdminScreens(state.user);
      },
      isSuperadmin: function isSuperadmin(state) {
        return isSuperadminUser(state.user);
      },
      ownedCommunities: function ownedCommunities(state) {
        return state.user ? state.land.filter(function (land) {
          return land.createdBy === state.userid;
        }) : [];
      },
      // fans per community id (communityFanCounts, core/server/userData.js)
      communityFanCounts: function communityFanCounts(state) {
        return state.fanCounts;
      },
      // owners must be verified before managing communities (D4); legacy screens enforce this in the UI only (D11)
      canManageCommunities: function canManageCommunities(state) {
        return !!state.user && (!isOwnerUser(state.user) || isVerifiedOwner(state.user));
      },
      emailTemplate: function emailTemplate(state) {
        return function (key) {
          var result;
          state.KV.forEach(function (kv) {
            if (kv.key === 'EMAIL_TEMPLATE') {
              result = kv;
            }
          });
          return result;
        };
      },
      emailTemplates: function emailTemplates(state, getters) {
        // return state.KV
        var templates = [];
        state.KV.forEach(function (kv) {
          if (kv.type === 'EMAIL_TEMPLATE') {
            templates.push(kv);
          }
        });
        return templates;
      },
      scoreSettings: function scoreSettings(state, getters) {
        // return state.KV
        var templates = [];
        state.KV.forEach(function (kv) {
          if (kv.group === 'SCORE') {
            templates.push(kv);
          }
        });
        return templates;
      },
      // emailTemplates2: (state, getters) => state.KV.find(kv => kv.type === 'EMAIL_TEMPLATE'),
      // emailTemplates: (state, getters) => state.KV.find(kv => kv.type === 'EMAIL_TEMPLATE'),
      outbox: function outbox(state, getters) {
        var messages = [];
        state.land.forEach(function (land) {
          land.messages.forEach(function (message) {
            if (message.createdBy === state.userid) {
              messages.push(message);
            }
          });
        });
        messages.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return messages;
      },
      inbox: function inbox(state, getters) {
        var messages = [];
        state.land.forEach(function (land) {
          land.messages.forEach(function (message) {
            if (message.cc.includes(state.userid)) {
              messages.push(message);
            }
          });
        });
        messages.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return messages;
      },
      hasInboxUnread: function hasInboxUnread(state, getters) {
        var found = false;
        getters.inbox.forEach(function (message) {
          if (!message.rcc.includes(state.userid)) {
            found = true;
          }
        });
        return found;
      },
      landByMessageId: function landByMessageId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.messages.find(function (message) {
              return message.id === id;
            });
          });
        };
      },
      isSubscribed: function isSubscribed(state) {
        return function (id) {
          if (state.user) {
            return state.user.profile.subs.indexOf(id) !== -1;
          } else {
            return false;
          }
        };
      },
      landByMeetingId: function landByMeetingId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.meetings.find(function (meeting) {
              return meeting.id === id;
            });
          });
        };
      },

      /* landByTag: state => tag => state.land.find(land => {
              return land.tags && land.tags.indexOf(tag) !== -1
          }
      ), */
      landByTag: function landByTag(state) {
        return function (id) {
          return state.land.find(function (land) {
            if (land.tags) {
              return land.tags.find(function (tag) {
                return tag.id === id;
              });
            } else {
              return null;
            }
          });
        };
      },
      landByThreadId: function landByThreadId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.threads.find(function (thread) {
              return thread.id === id;
            });
          });
        };
      },
      landByPollId: function landByPollId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.polls.find(function (poll) {
              return poll.id === id;
            });
          });
        };
      },
      landByPolisId: function landByPolisId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.polis.find(function (polis) {
              return polis.id === id;
            });
          });
        };
      },
      landByPledgeId: function landByPledgeId(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.pledges.find(function (pledge) {
              return pledge.id === id;
            });
          });
        };
      },
      measure: function measure(state) {
        return function (id) {
          return state.measures.find(function (measure) {
            return measure.id === id;
          });
        };
      },
      userData: function userData(state) {
        return function (id) {
          return state.userData.find(function (item) {
            return item._id === id;
          });
        };
      },
      userDataAll: function userDataAll(state, getters) {
        return state.userData;
      },
      // fans only: no owner, admin or superadmin accounts (api/core/roles isFan)
      fans: function fans(state) {
        return state.userData.filter(isFan);
      },
      land: function land(state) {
        return function (id) {
          return state.land.find(function (land) {
            return land.id === id;
          });
        };
      },
      measuresAll: function measuresAll(state, getters) {
        return state.measures;
      },
      // measures: (state, getters) => {
      //     const temp = state.measures
      //     // return state.measures.filter(measure => !measure.like)
      //     return temp
      // },
      // measuresByUserId: state => id => state.measures.find(measure => measure.createdBy === id),
      // measuresByUserId: state => id => state.measures.filter(measure => measure.createdBy === id),
      measuresByUserId: function measuresByUserId(state) {
        // 1. Force Vue 2 to register 'state.measures' as a dependency
        var allMeasures = state.measures; // 2. Return the function that filters the tracked data

        return function (id) {
          return allMeasures;
        }; // .filter(measure => measure.createdBy === id)
      },
      lands: function lands(state, getters) {
        // return state.measures.filter(measure => !measure.like)
        return state.land;
      },
      measuresNotLike: function measuresNotLike(state, getters) {
        return state.measures.filter(function (measure) {
          return !measure.like === true;
        });
      },
      measuresMine: function measuresMine(state, getters) {
        return state.measuresMine;
      },
      measuresReady: function measuresReady(state) {
        return state.ready;
      },
      // the app loader (#223): the steps the first page waits for, in the order the loader ticks them. Logged out
      // the welcome pages only need the settings; logged in every page may use any of the start-up data. Before
      // the login is known, a stored login means it will be the logged-in list
      startSteps: function startSteps(state) {
        var loggedIn = state.loginKnown ? !!state.user : hasStoredLogin();
        var s = state.subsReady;
        var steps = loggedIn ? [['connect', state.loginKnown], ['account', state.loginKnown && s.users], ['places', s.measures], ['communities', s.land], ['news', s.KV && s.notices]] : [['connect', state.loginKnown], ['settings', s.KV]];
        return steps.map(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
              key = _ref14[0],
              done = _ref14[1];

          return {
            key: key,
            done: !!done
          };
        });
      },
      // 0..1
      startProgress: function startProgress(state, getters) {
        var steps = getters.startSteps;
        return steps.filter(function (step) {
          return step.done;
        }).length / steps.length;
      },
      appReady: function appReady(state, getters) {
        return state.loginKnown && getters.startProgress === 1;
      },
      communitySubscribed: function communitySubscribed(state, getters) {
        if (state.user) {
          /* if (state.user.profile.admin) {
              return state.land
          } else */
          if (state.user.profile.owner) {
            return state.land.filter(function (land) {
              return land.createdBy === state.userid;
            });
          } else {
            var subIds = state.user.profile.subs;
            return state.land.filter(function (land) {
              return subIds.indexOf(land.id) !== -1;
            });
          }
        } else {
          return [];
        }
      },
      landsOwner: function landsOwner(state, getters) {
        if (state.user) {
          if (state.user.profile.admin) {
            return state.land;
          } else {
            return state.land.filter(function (land) {
              return land.createdBy === state.userid;
            });
          } // let subIds = state.user.profile.subs

        } else {
          return [];
        }
      },
      isModerator: function isModerator(state, getters) {
        return function (id) {
          if (id && state.authenticated && getters.canManageCommunities) {
            var land = getters.land(id);
            return land.mods.includes(state.user._id);
          } else {
            return false;
          } // let land = getters.land(id)
          // let bool =
          //
          // return state.authenticated && bool

        };
      },
      isOwner: function isOwner(state, getters) {
        return function (id) {
          if (id && state.authenticated && getters.canManageCommunities) {
            if (state.user.admin) {
              return true;
            } else {
              var land = getters.land(id);
              return land.createdBy === state.user._id;
            }
          } else {
            return false;
          } // let land = getters.land(id)
          // let bool =
          //
          // return state.authenticated && bool

        };
      },
      isAuthenticated: function isAuthenticated(state) {
        return state.authenticated;
      },
      userid: function userid(state) {
        return state.userid;
      },
      user: function user(state) {
        return state.user;
      },
      getCenter: function getCenter(state) {
        // return state.authenticated ? state.user.profile.centerCoordinates : [6.589560, 53.214578]
        return state.authenticated ? state.user.profile.centerCoordinates : [6.589560, 53.214578];
      },
      bannerAd: function bannerAd(state) {
        if (state.adverts) {
          var result = state.adverts.find(function (ad) {
            return ad.position === 'BANNER';
          });
          return result;
        }
      },
      timelineAd: function timelineAd(state) {
        if (state.adverts) {
          var result = state.adverts.find(function (ad) {
            return ad.position === 'TIMELINE';
          });
          return result;
        }
      },
      tipsVoedselAd: function tipsVoedselAd(state) {
        if (state.adverts) {
          var result = state.adverts.find(function (ad) {
            return ad.position === 'TIPSVOEDSEL';
          });
          return result;
        }
      },
      tipsNestelAd: function tipsNestelAd(state) {
        if (state.adverts) {
          var result = state.adverts.find(function (ad) {
            return ad.position === 'TIPSNESTEL';
          });
          return result;
        }
      },
      subCount: function subCount(state) {
        return function (communityId) {
          return state.fanCounts[communityId] || 0;
        };
      },
      jointSurfaceMyAreas: function jointSurfaceMyAreas(state) {
        var totalArea;

        if (!state.measuresMine || state.measuresMine.length < 1) {
          totalArea = 0; // setTimeout(() => { this.calcAvgRating() }, 1000)
        } else {
          totalArea = Math.ceil(state.measuresMine.reduce(function (sum, measure) {
            return sum + geojsonArea.geometry(measure.geometry);
          }, 0) / 1000000);
        }

        return totalArea;
      },
      // the joint surface of the communities the fan joined, in km² (as jointSurfaceMyAreas)
      jointSurfaceCommunities: function jointSurfaceCommunities(state, getters) {
        var communities = getters.communitySubscribed;
        if (!communities || communities.length < 1) return '';
        return Math.ceil(communities.reduce(function (sum, community) {
          return sum + geojsonArea.geometry(community.geometry);
        }, 0) / 1000000);
      } // getScore (state) {
      //     let score = -1
      //     if (state.authenticated) {
      //         score = state.measures.filter(measure => measure.createdBy === state.user.id)
      //     }
      //     let
      //     return score
      // }

    }
  });
  storeInstance = Store;
  return Store;
}
export { storeInstance };